import { authReducer } from '../auth/state/auth.reducer';
import { UserData } from '../auth/state/auth.state';
import {
  Cartdata,
  DeliverDetailsData,
  ProductsData,
} from '../click-it/create-order/cement/cement-state/cement-state';
import {
  cartReducer,
  deliverydetailsReducer,
  productDetailsReducer,
} from '../click-it/create-order/cement/cement-state/cement.reducers';
import { helpCenterReducer } from '../click-it/help-center/help-center-state/help-center-reducers';
import { HelpCenter } from '../click-it/help-center/help-center-state/help-center-state';
import { promotionReducer } from '../click-it/more/promotion/promotion-state/promotion-reducers';
import { Promotion } from '../click-it/more/promotion/promotion-state/promotion-state';
import { OrderData } from '../click-it/orders/cement/order-cement-state/order-cement-state';
import { orderReducer } from '../click-it/orders/cement/order-cement-state/order.reducers';

export interface AppState {
  authState: UserData;
  cartState: Cartdata;
  deliverydetailsState: DeliverDetailsData;
  orderState: OrderData;
  helpCenterState: HelpCenter;
  productsState: ProductsData;
  promotionState: Promotion;
}

export const appReducer = {
  authReducer: authReducer,
  cartReducer: cartReducer,
  deliverydetailsReducer: deliverydetailsReducer,
  orderReducer: orderReducer,
  helpCenterReducer: helpCenterReducer,
  productDetailsReducer: productDetailsReducer,
  promotionReducer: promotionReducer,
};
